import React, { useContext, useState, useEffect } from "react";
import {
  getBirthdayInFormat,
  getDate,
  getMonths,
  getYears,
  simplyClick,
  validateAge,
} from "../../helpers";
import ButtonSubmit from "../buttonSubmit";
import "./birthdayForm.scss";
import { errorEventsBirthday } from "../../constants";
import { ContextProfileUser } from "../../lib/profileContext";
import cn from "classnames";
import ProgressDots from "../ProgressDots/ProgressDots";

function BirthdayForm({ nextStep }) {
  const [errorDate, setErrorDate] = useState({
    month: false,
    day: false,
    year: false,
    message: null,
  });
  // const [data, setBirthdayData] = useState({});
  const [value, setValue] = useState("default");
  const { data, setData } = useContext(ContextProfileUser);

  useEffect(() => {
    const allFilled = data.month && data.day && data.year;

    if (allFilled) {
      setErrorDate({
        month: false,
        day: false,
        year: false,
        message: null,
      });
    }
  }, [data]);

  const handlerSubmit = (e) => {
    e.preventDefault();

    const hasMonth = Boolean(data.month);
    const hasDay = Boolean(data.day);
    const hasYear = Boolean(data.year);

    if (!hasDay && !hasMonth && !hasYear) {
      simplyClick("err_lnd_age_nodate");
      setErrorDate({
        month: true,
        day: true,
        year: true,
        message: "Please enter your date of birth",
      });
      return;
    }

    const dateKey = [
      hasMonth ? "M" : "",
      hasDay ? "D" : "",
      hasYear ? "Y" : "",
    ].join("");

    if (errorEventsBirthday[dateKey]) {
      simplyClick(errorEventsBirthday[dateKey]);
      setErrorDate({
        month: !hasMonth,
        day: !hasDay,
        year: !hasYear,
        message: "Please enter your date of birth",
      });
      return;
    }

    const { error, status, errors } = validateAge(
      data.month,
      data.day,
      data.year
    );

    if (!status) {
      setErrorDate({
        month: errors.month || errors.invalidDate,
        day: errors.day || errors.invalidDate,
        year: errors.year || errors.invalidDate,
        message: error,
      });
      return;
    }

    const formattedDate = getBirthdayInFormat(data.year, data.month, data.day);

    setData({
      ...data,
      birthday: formattedDate,
    });

    simplyClick("cl_lnd_date_birth_next", { text: formattedDate });

    nextStep();
  };

  const handleAddMonth = ({ target: { value } }) => {
    setData((prev) => ({ ...prev, month: value }));
    setErrorDate((prev) => ({ ...prev, month: false }));
    simplyClick("cl_lnd_date_birth_month_choose", { text: value });
  };

  const handleAddDay = ({ target: { value } }) => {
    setData((prev) => ({ ...prev, day: value }));
    setErrorDate((prev) => ({ ...prev, day: false }));
    simplyClick("cl_lnd_date_birth_day_choose", { text: value });
  };

  const handleAddYear = ({ target: { value } }) => {
    setData((prev) => ({ ...prev, year: value }));
    setErrorDate((prev) => ({ ...prev, year: false }));
    simplyClick("cl_lnd_date_birth_year_choose", { text: value });
  };

  return (
    <div className="promo__wrapper-birthday">
      <div className="user__form-top">
        <h3>My date of birth</h3>
      </div>
      <form className="form__date" onSubmit={handlerSubmit}>
        <div className="dates_error">
          <div className="date__wrapper">
            <div className="select-container aqa-test-month">
              <select
                className={cn({
                  active: data.month,
                  error: errorDate.month,
                })}
                onChange={handleAddMonth}
                defaultValue={data.month || "default"}
              >
                <option value="default" disabled hidden>
                  Month
                </option>
                {getMonths().map((item, index) => (
                  <option key={index} value={index + 1}>
                    {item || ""}
                  </option>
                ))}
              </select>
            </div>
            <div className="select-container aqa-test-day">
              <select
                className={cn({
                  active: data.day,
                  error: errorDate.day,
                })}
                onChange={handleAddDay}
                defaultValue={data.day || "default"}
              >
                <option value="default" disabled hidden>
                  Day
                </option>
                {getDate().map((item, index) => (
                  <option key={index} value={item}>
                    {item || ""}
                  </option>
                ))}
              </select>
            </div>
            <div className="select-container aqa-test-year">
              <select
                className={cn({
                  active: data.year,
                  error: errorDate.year,
                })}
                onChange={handleAddYear}
                defaultValue={data.year || "default"}
              >
                <option value="default" disabled hidden>
                  Year
                </option>
                {getYears().map((item, index) => (
                  <option key={index} value={item}>
                    {item || ""}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {errorDate.message && (
            <p className="errorDate">{errorDate.message}</p>
          )}
        </div>
        <div className={"birthday_confirm"}>
          By proceeding, you confirm you are at least 18 years old and fully legally capable of using our website
        </div>

        <ButtonSubmit
          className={"button__global button__birthday"}
          text={"NEXT"}
        />
        <ProgressDots total={6} activeCount={3} />
      </form>
    </div>
  );
}

export default BirthdayForm;
